export const WHATSAPP_NUMBER = "919996426868";
export const WHATSAPP_DISPLAY = "+91 99964 26868";

export const OFFICE_ADDRESS = "Shop No. 36, Pawan Market, Pehowa 136128, Haryana, India";

export const waLink = (text = "Hi Gautam Travel! I'd like to plan a trip.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const CONTACTS = [
  { label: "Canada Manager — Sahil Sharma", phone: "+1 647 867 2708", tel: "+16478672708" },
  { label: "India Office Administrative — Kritika Sharma", phone: "+91 99966 08313", tel: "+919996608313" },
];

export const EMAILS = ["mgautam816@gmail.com", "gautam.travels.in@gmail.com"];

export const INSTAGRAM_URL = "https://www.instagram.com/mohit_sharma_gtt";
export const YOUTUBE_URL = "https://youtube.com/@gautamtourtravel";

export const UPI_ID = "9996426868-1@okbizaxis";
export const UPI_PAYEE = "Gautam Tour And Travels";
export const UPI_URL = "upi://pay?pa=9996426868-1@okbizaxis&pn=Gautam%20Tour%20And%20Travels&mc=4722&aid=uGICAgMC574ibdg&ver=01&mode=01&tr=BCR2DN4TQHC2VNKN";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const IS_STATIC = process.env.REACT_APP_STATIC === "true";

export const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const scrollToId = (e, id) => {
  e?.preventDefault();
  if (window.location.pathname !== "/") {
    window.location.href = "/" + (id === "body" ? "" : id);
    return;
  }
  document.querySelector(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};
